import { styled } from "@mui/material";

export const Div = styled("div")({});

export type DivProps = typeof Div extends (props: infer P) => any ? P : never;

export default Div;
